import axios from 'axios'
import qs from 'qs'
import { getToken, removeBindMobile, removeToken, removeUserInfo, removeWXInfo } from '@/libs/cookie-storage'
import { StringUtil } from '@/utils'
import Vue from 'vue'
import { Toast } from 'vant'
import router from "@/router";
import wx from 'weixin-js-sdk'
import { AppType } from '@/constants/appType'
import { buildFullHashRedirectUrl } from '@/utils/redirect'

// import store from "@/store";
// import router from '@/router'
Vue.use(Toast)
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BANMA_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.data && config.qs !== false) {
      config.data = qs.stringify(config.data)
    }
    config.params = config.params || {}
    // 处理app中URL中passport参数
    // const query = UrlUtil.getUrlQueryParams()
    const token = getToken()
    if (token) {
      config.params.passport = token
    }
    // else if (query && query.passport) {
    //   setToken(query.passport)
    //   config.params.passport = query.passport
    // }
    // get method, params object to url query string
    // avoid param value contains url bug
    config.url += StringUtil.isEmptyStr(config.params) ? '' : '?' + qs.stringify(config.params)
    config.params = null
    // 开启loading
    // Toast.loading({
    //   forbidClick: true
    // })
    if (config.url.includes('upload.qiniup.com')) {
      Toast.loading({
        message: '上传中...',
        forbidClick: true,
      })
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  async response => {
    const res = response.data
    if (response.config.url.includes('upload.qiniup.com')) { // 上传文件
      Toast.clear()
      return res
    }
    if (res.error || res.code !== 200) {
      const error = res.messages.error
      let message = ''
      if (loginJudgment(error)) {
        console.log(1);
      }
      else {
        if (res.code === 500 && error.code === 'internal_error') {
          message = '内部错误：' + error.message
        } else {
          message = error.message
        }
        Toast(message)
      }
      return Promise.resolve(false)
    } else {
      return res.messages
    }
  },
  error => {
    console.log('err' + error) // for debug
    if (loginJudgment(error)) {
      console.log(2);
    } else {
      Toast(error.message)
    }
    return Promise.reject(error)
  }
)


function loginJudgment(error) {
  error.message = JSON.stringify(error.message)
  if (
    error.code === 'login_required' ||
    error.code === 'login_account_expired' ||
    error.code === 'login_account_denied' ||
    error.message.includes('login_required') ||
    error.message.includes('login_account_expired') ||
    error.message.includes('login_account_denied')
  ) {
    login(error)
    return true
  } else {
    return false
  }
}
function login(error) {
  removeToken()
  removeUserInfo()
  removeWXInfo()
  removeBindMobile()
  const redirect = (window.location.hash || '').substring(1)
  const ua = window.navigator.userAgent.toLowerCase()
  if (AppType.isInWeChat() && ua.indexOf('micromessenger') > -1) {
    wx.miniProgram.navigateTo({
      url: '/pages/common/login?redirect=' + encodeURIComponent(buildFullHashRedirectUrl(redirect ? ('/' + redirect.replace(/^\//, '')) : ''))
    })
  } else {
    if (window.localStorage.getItem('jetlympic') || window.localStorage.getItem('activityOsten')) {
      router.replace({ name: 'JetlympicLogin', query: { redirect: encodeURIComponent(redirect) } })
    } else {
      router.replace({ name: 'AuthLogin', query: { redirect: encodeURIComponent(redirect) } })
    }
  }
  let message = ''
  message = error.message
  Toast(message)
}
export default service
